import { useEffect, useRef } from "react"
import { css } from "@emotion/css"
import { endOfDay, startOfDay, startOfYear, sub } from "date-fns"
import { DateRangeAgain } from "components/inputs/DateRange"
import { useLocationSearch } from "hooks/useLocationSearch"

import { serialize, deserialize } from "./dates"
import { useI18n } from "providers/I18n"
import { zonedTimeToUtc } from "date-fns-tz"
import { useAuthenticated } from "providers/A12n"

export type DateRangeFilterProps = {
  addDefaultRange?: boolean
  disabled?: boolean
}
export function DateRangeFilter(props: DateRangeFilterProps) {
  const { t } = useI18n()
  const { meta } = useAuthenticated()
  const { timeZone = "Etc/UTC" } = meta ?? {}
  const { addDefaultRange = true, disabled = false } = props
  const addDefaultRangeRef = useRef<boolean>(addDefaultRange)
  addDefaultRangeRef.current = addDefaultRange

  const ls = useLocationSearch()
  const startDate = ls.get("startDate", "")!
  const endDate = ls.get("endDate", "")!

  useEffect(() => {
    if (!addDefaultRangeRef.current) return
    const startDate = ls.get("startDate", "")!
    const endDate = ls.get("endDate", "")!
    if (!startDate.trim()) {
      ls.set("startDate", serialize(startOfYear(new Date())))
    }
    if (!endDate.trim()) {
      ls.set("endDate", serialize(new Date()))
    }
    //eslint-disable-next-line
  }, [])

  const onDateRangeChange = (s: Date | null, e: Date | null) => {
    if (s) {
      ls.set("startDate", serialize(zonedTimeToUtc(startOfDay(s), timeZone)))
    }
    if (e) {
      ls.set("endDate", serialize(zonedTimeToUtc(endOfDay(e), timeZone)))
    }

    //
    ls.set("q", "")
  }
  const onDateRangeClear = () => {
    ls.set("startDate", "")
    ls.set("endDate", "")
    //
    ls.set("q", "")
  }

  const now = useRef<number>(Date.now())

  // start of last year
  const minDate = sub(startOfYear(now.current), { years: 1 })

  return (
    <div>
      <DateRangeAgain
        minDate={minDate}
        label={t("filters.date")}
        start={deserialize(startDate.trim())}
        end={deserialize(endDate.trim())}
        onRangeChange={onDateRangeChange}
        onRangeClear={onDateRangeClear}
        disabled={disabled}
        fullWidth
        hasStartAdornment
        inputClassName={css`
          background-color: #fff;
        `}
        notchedClasName={css`
          border: 1px solid var(--disabled-grey);
          padding: revert;
        `}
      />
    </div>
  )
}
